/** For admins: choose which of their assemblies to open (surveyors never see this). */
import { useEffect, useState } from "react";
import type { AssemblyInfo } from "../field/api";
import { useApp, useSession } from "../ui/context";
import { navigate } from "../ui/router";
import { Banner, Button } from "../ui/components";

export function AssemblyPick() {
  const { app, t, lang } = useApp();
  const { user, assemblyId } = useSession();
  const [list, setList] = useState<AssemblyInfo[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  const load = () => {
    setError(null);
    app.listAssemblies().then(setList, (e) => setError(e instanceof Error ? e.message : String(e)));
  };
  useEffect(load, [app]);

  const allowed = (list ?? []).filter((a) => !user?.assemblyIds || user.assemblyIds.includes(a.id));
  return (
    <div className="stack">
      <h2>{t.chooseAssembly}</h2>
      {error ? <Banner kind="error" action={{ label: t.retry, onClick: load }}>{`${t.downloadFailed} (${error})`}</Banner> : null}
      {!list && !error ? <p>{t.loading}</p> : null}
      {allowed.map((a) => (
        <Button
          key={a.id}
          variant={a.id === assemblyId ? "primary" : "secondary"}
          busy={busy === a.id}
          disabled={!!busy}
          sub={a.id}
          onClick={async () => {
            setBusy(a.id);
            try {
              await app.chooseAssembly(a.id);
              navigate({ name: "home" });
            } finally {
              setBusy(null);
            }
          }}
        >
          {(lang === "hi" && a.nameHi) || a.name}
        </Button>
      ))}
    </div>
  );
}
